// extracted by mini-css-extract-plugin
export var bodySections = "_9m-8";
export var gray = "_9m-7";
export var green = "_9m-4";
export var iconContainer = "_9m-9";
export var iconWidgetContainer = "_9m-1";
export var phoneIcon = "_9m-2";
export var red = "_9m-5";
export var statusDot = "_9m-3";
export var widgetContainer = "_9m-0";
export var yellow = "_9m-6";